import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { Car } from 'app/models/car.model';
import { FastTaskProcessing } from 'app/models/fast-task-processing.model';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class FastTaskProcessingService {

    fastTaskProcessing: any[];
    onChanged: BehaviorSubject<any>;

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) {
        this.onChanged = new BehaviorSubject({});
    }

    fastTaskUpdate(entity: Car): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "fastTaskProcessing/update", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    getFastTask(companyId:number): Promise<Array<FastTaskProcessing>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "fastTaskProcessing/"+companyId)
                .subscribe((response: any) => {
                    debugger;
                    resolve(response);
                }, reject);
        });
    }
}
